import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(legal)/terms-of-service")({
  component: TermsOfService,
});

function TermsOfService() {
  return (
    <div className="px-4 py-10 flex justify-center">
      <div className="w-full max-w-2xl">
        <Button
          onClick={() => window.history.back()}
          variant="outline"
          className="mb-4"
        >
          ← Go Back
        </Button>
        <Card>
          <CardContent className="p-6 space-y-6">
            <h1 className="text-3xl font-semibold">Terms of Service</h1>

            <p>
              Welcome to the application developed by Crayons Code. By accessing
              or using our services, you agree to comply with these Terms of
              Service. Please read them carefully.
            </p>

            <h2 className="text-xl font-semibold">1. Use of Our Service</h2>
            <p>
              You agree to use the service only for lawful purposes and in a way
              that does not infringe the rights of others or restrict their use
              and enjoyment of the service.
            </p>

            <h2 className="text-xl font-semibold">2. Account Responsibility</h2>
            <p>
              If you create an account, you are responsible for safeguarding
              your login credentials and all activities under your account.
            </p>

            <h2 className="text-xl font-semibold">3. Intellectual Property</h2>
            <p>
              All content, features, and functionality provided by this
              application are the exclusive property of Crayons Code and are
              protected by intellectual property laws.
            </p>

            <h2 className="text-xl font-semibold">
              4. Modifications to the Service
            </h2>
            <p>
              Crayons Code reserves the right to modify or discontinue the
              service at any time without notice.
            </p>

            <h2 className="text-xl font-semibold">5. Termination</h2>
            <p>
              We may suspend or terminate your access to the service if you
              violate these terms or for any reason we deem necessary.
            </p>

            <h2 className="text-xl font-semibold">
              6. Limitation of Liability
            </h2>
            <p>
              Crayons Code is not liable for any direct, indirect, incidental,
              or consequential damages arising from your use of the service.
            </p>

            <h2 className="text-xl font-semibold">7. Governing Law</h2>
            <p>
              These terms shall be governed by the laws applicable in the
              jurisdiction where Crayons Code operates.
            </p>

            <h2 className="text-xl font-semibold">8. Changes to Terms</h2>
            <p>
              We may update these Terms of Service occasionally. Continued use
              of the service after changes constitutes your acceptance of the
              updated terms.
            </p>

            <p className="text-sm text-muted-foreground">
              If you have any questions, please contact us at
              support@crayonscode.com.
            </p>

            <div className="text-center text-sm text-muted-foreground mt-8">
              Last updated: July 13, 2025
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
